// AffiliateWP attribution constants shared across the affiliate utilities.
// Intentionally side-effect free (no env reads) so it's safe to import from
// anywhere, including cross-domain surfaces like freemode that don't set the WP
// cookie envs `affiliate-tracking.ts` relies on.

/** Cookie AffiliateWP stores the affiliate ref id in. */
export const AFFILIATE_ID_COOKIE_NAME = 'affwp_ref'

/**
 * AffiliateWP's referral attribution window, in days. The WP cookie is set with
 * this expiry; the localStorage fallback mirrors it so a captured ref can't
 * outlive the commission window.
 */
export const REFERRAL_ATTRIBUTION_WINDOW_DAYS = 90
